import { facadeFactory } from '@spartacus/core'
import { Injectable } from '@angular/core'
import { MbCheckoutContactDetailsModel } from '../../models'
import { CHECKOUT_CORE_FEATURE } from '@spartacus/checkout/base/root'

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: MbCheckoutContactDetailsFacade,
      feature: CHECKOUT_CORE_FEATURE,
      methods: [
        'createAndSetContactDetails'
      ],
      async: true,
    }),
})
export abstract class MbCheckoutContactDetailsFacade {
  /**
   * Create and set contact details for checkout
   *
   * @param contactDetails : Contact details to be created and set
   */
  abstract createAndSetContactDetails(contactDetails: MbCheckoutContactDetailsModel): void
}
